import { TasksIcon } from "@icons";
import styles from "./RefGlyph.module.scss";

export const TaskGlyph = () => (
    <TasksIcon className={styles.glyph} aria-hidden />
);
